import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IPaymentRequestApiClient } from './i-payment-request.api.client';
import { CollectionApiClient, IPaginationParameters, IPaginationResponse } from '../../../common';
import { PaymentManagementCollections } from '../../common';
import { IPaymentRequestResponse } from '../dtos';

@Injectable({
  providedIn: 'root'
})
export class PaymentRequestApiClient implements IPaymentRequestApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(PaymentManagementCollections.PaymentRequests, http);
  }
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IPaymentRequestResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<IPaymentRequestResponse> {
    return this.collectionApiClient.get({
      id
    });
  }
}